import styles from "./NotePatches.module.css";

interface ViewersProps {
  editMode: boolean;
  viewers: string[];
}

export const Viewers = ({ editMode, viewers }: ViewersProps) => {
  return (
    !editMode &&
    viewers.length > 0 && (
      <div className={styles.viewers}>
        <p>Просмотры</p>
        {viewers.map((v) => (
          <span key={v}>{v}</span>
        ))}
      </div>
    )
  );
};
